import {
  Button,
  Divider,
  Grid,
  InputLabel,
  Link,
  Typography,
  TextField,
  Box,
  Paper,

} from "@mui/material";
import React, { useState, useEffect } from "react";
import CustomInput from "./custom-input";
import { Controller, useForm, useWatch } from "react-hook-form";
import { Doughnut } from 'react-chartjs-2';
import CustomInputSameRow from "./custom-input2";
import CalInfo from "./CalInfo";
import {
  InputAdornment,

} from '@material-ui/core';


import {
  Chart,
  PieSeries,
  Title,
  Label,

} from '@devexpress/dx-react-chart-material-ui';



const Cal2 = () => {


  const [isMobile, setIsMobile] = useState(false);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 600); // Adjust breakpoint as needed
    };

    handleResize(); // Check on initial render
    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  const maxLength = 10;

  const validateDigits = (value) => {

    const digitRegex = /^\d*$/;
    return value.length <= maxLength && digitRegex.test(value);
  };


  const { control, handleSubmit, formState: { errors }, setValue } = useForm({
    defaultValues: {
      principal: "400000",
      downPaymentPercentage: 20,
      interestRate: 7.03,
      loanTerm: 30,
      propertyTax: 200,
      homeInsurance: 200,
      pmi: 200,
      hoaFees: 200,
      monthlyPayment: 0,
      principalAndInterest: 0,
      totalMonthlyPayment: 0
    }
  });

  const {
    principal,
    downPaymentPercentage,
    interestRate,
    loanTerm,
    propertyTax,
    homeInsurance,
    pmi,
    hoaFees,
    principalAndInterest,
    totalMonthlyPayment,
    zip
  } = useWatch({ control });



  const calculateMonthlyPayment = () => {



  }





  useEffect(() => {
    const loanAmount = parseFloat(principal * (100 - downPaymentPercentage)) / 100;
    const interest = parseFloat(interestRate) / 100 / 12;
    const loanDuration = parseFloat(loanTerm) * 12;

    if (loanAmount && interest && loanDuration) {
      const monthlyRate = Math.pow(1 + interest, loanDuration);
      const monthlyPayment = (loanAmount * interest * monthlyRate) / (monthlyRate - 1);
      setValue('principalAndInterest', monthlyPayment.toFixed(2))
      console.log('calculating...', monthlyPayment.toFixed(2))

    } else {
      // setMonthlyPayment(0);
      // onMonthlyPaymentChange(0); // Pass 0 as the monthly payment to the parent component
    }
  }, [principal, downPaymentPercentage, interestRate, loanTerm]);


  useEffect(() => {
    const pI = parseFloat(principalAndInterest)
    const pT = parseFloat(propertyTax)
    const hI = parseFloat(homeInsurance)
    const pMi = parseFloat(pmi)
    const hF = parseFloat(hoaFees)
    const totMonthlyPay = pI + pT + hI + pMi + hF
    setValue('totalMonthlyPayment', totMonthlyPay)


  }, [principalAndInterest, propertyTax, homeInsurance, pmi, hoaFees]);



  const data = [
    { argument: "Property Tax", value: propertyTax },
    { argument: "Home Insurance", value: homeInsurance },
    { argument: "PMI", value: pmi },
    { argument: "HOA Fees", value: hoaFees },
    { argument: "Principal & Interest", value: principalAndInterest },
  ];
  //const colorScheme = ["#1f77b4", "#ff7f0e", "#2ca02c", "#d62728", "#9467bd"];

  const colorScheme = [
    '#4ba3c7',
    '#0099FF',
    '#ff6347',
    '#9ACD32',
    '#ffa500'
  ];




  const chartContainerStyle = {
    position: 'relative',
    width: '100%',
    height: '100%', // Set the height accordingly
  };

  const centerLabelStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  };

  function formatNumberWithCommas(number) {
    return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  const circleStyle = {
    display: 'inline-block',
    width: '15px', // Adjust size as needed
    height: '15px', // Adjust size as needed
    borderRadius: '50%',
    backgroundColor: 'red', // Change the color to your desired color
    marginRight: '5px', // Adjust spacing between circle and text
  };



  const pieSeries = data.map((item, index) => ({
    valueField: 'value',
    argumentField: 'argument',
    innerRadius: 0.6,
    color: colorScheme[index % colorScheme.length], // Cycling through colorScheme array for each series
    key: `pie-series-${index}`,
  }));

  return (

    <>
      <form >
        {/* <Box maxWidth="xl" ml={isMobile ? 1 : 6} mr={6} bgcolor={'#ffffff'}> */}
        <Grid container direction="column" p={isMobile ? 2 : 11}>
          <Grid item container direction={"column"}>
            <Grid item mt={isMobile ? 8 : 0}>
              <Typography variant="h2" fontSize={32} fontWeight={700} sx={{ color: '#31B9B5' }}>Mortgage Calculator</Typography>
            </Grid>

            <Grid mt={4}>
              <Grid
                item
                container
                direction={"row"}
                justifyContent={"space-between"}
              >
                <Grid item md={5}>

                  <Controller
                    name="principal"
                    control={control}

                    render={({ field }) => (
                      <CustomInput
                        {...field}
                        style={{ backgroundColor: 'white', borderRadius: '8px' }}
                        type={'text'}
                        required
                        boxProps={{ my: 2 }}
                        size="small"
                        fullWidth
                        label={"Home Price"}
                        placeholder={"Enter Home Price"}
                        state={principal}
                      // onChange={calculateMonthlyPayment}
                      />
                    )}
                  />

                </Grid>
                <Grid item md={5}>
                  <Controller
                    name="downPaymentPercentage"
                    control={control}

                    render={({ field }) => (
                      <CustomInput
                        {...field}
                        style={{ backgroundColor: 'white', borderRadius: '8px' }}
                        type={'text'}
                        required
                        boxProps={{ my: 2 }}
                        size="small"
                        fullWidth
                        label={"Down Payment (%):"}
                        placeholder={"Enter Down Payment %"}
                        state={downPaymentPercentage}
                      // onChange={calculateMonthlyPayment}
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid
                item
                container
                direction={"row"}
                justifyContent={"space-between"}
              >
                <Grid item md={5}>
                  <Controller
                    name="loanTerm"
                    control={control}

                    render={({ field }) => (
                      <CustomInput
                        {...field}
                        style={{ backgroundColor: 'white', borderRadius: '8px' }}
                        type={'text'}
                        required
                        boxProps={{ my: 2 }}
                        size="small"
                        fullWidth
                        label={"Loan Term (in years)"}
                        placeholder={"Enter loan term (yr)"}
                        state={loanTerm}
                      //  onChange={calculateMonthlyPayment}
                      />
                    )}
                  />
                </Grid>
                <Grid item md={5}>
                  <Controller
                    name="interestRate"
                    control={control}

                    render={({ field }) => (
                      <CustomInput
                        {...field}
                        style={{ backgroundColor: 'white', borderRadius: '8px' }}
                        type={'text'}
                        required
                        boxProps={{ my: 2 }}
                        size="small"
                        fullWidth
                        label={"Interest Rate (%):"}
                        placeholder={"Enter interest rate"}
                        state={interestRate}
                      // onChange={calculateMonthlyPayment}
                      />
                    )}
                  />
                </Grid>
              </Grid>
              <Grid
                item
                container
                direction={"row"}
                justifyContent={"space-between"}
              >
                <Grid item md={5}>
                  <Controller
                    name="zip"
                    control={control}

                    render={({ field }) => (
                      <CustomInput
                        {...field}
                        style={{ backgroundColor: 'white', borderRadius: '8px' }}
                        type={'text'}
                        required
                        boxProps={{ my: 2 }}
                        size="small"
                        fullWidth
                        label={"Loan Amount"}
                        placeholder={"Enter loan amount"}
                        state={zip}
                      // onChange={calculateMonthlyPayment}
                      />
                    )}
                  />
                </Grid>
                <Grid item md={5}>

                </Grid>
              </Grid>
              <Grid
                item
                container
                direction={"row"}
                justifyContent={"space-between"}
              >
                <Grid item md={5}>

                </Grid>
                <Grid item mt={5}>

                </Grid>
              </Grid>
            </Grid>

          </Grid>
          <Grid item>
            <Divider />
          </Grid>

          {/* <Grid item>

            <Box border={1} borderColor="red" height={574}>

              </Box>
            
              
            </Grid> */}
          <Grid item md={5}>
            <Grid container justifyContent="space-between">
              {!isMobile && (
                <Grid item md={6}>
                  <Box style={{ height: '100%' }}>
                    {/* <Doughnut data={updatedChartData} options={options} /> */}

                    <div style={chartContainerStyle}>
                      <Chart
                        data={data}
                      >
                        {pieSeries.map(series => (
                          <PieSeries
                            {...series}
                          />
                        ))}
                        <Title text="" />

                      </Chart>

                      {/* <div style={centerLabelStyle}>
                        <Typography variant="h12" style={{ fontFamily: 'Inter', fontWeight: 200, }}>
                          Total Monthly Payment
                        </Typography>
                        <Typography variant="h6" style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: 25, marginTop: 5, marginLeft: '50px' }}>
                          <span style={{ verticalAlign: 'super', fontSize: '20px', fontWeight: 500, marginRight: '10px' }}>$</span>{formatNumberWithCommas(totalMonthlyPayment)}
                        </Typography>
                      </div> */}

                      <div style={centerLabelStyle}>
                        <Typography variant="h12" style={{ fontFamily: 'Inter', fontWeight: 200 }}>
                          Total Monthly Payment
                        </Typography>
                        <Typography variant="h6" style={{ fontFamily: 'Inter', fontWeight: 400, fontSize: 25, marginTop: 5, marginLeft: '50px' }}>
                          <span style={{ verticalAlign: 'super', fontSize: '20px', fontWeight: 500, marginRight: '10px' }}>$</span>{formatNumberWithCommas(totalMonthlyPayment)}
                        </Typography>
                      </div>

                    </div>


                  </Box>
                </Grid>)}
              <Grid item md={isMobile ? 1 : 6}>
                <Box style={{ height: '100%' }}>



                  <Grid mt={4}>
                    <Grid item md={8}>
                    </Grid>
                  </Grid>

                  <Grid container spacing={2}>
                    <Grid container item spacing={2}>
                      <Grid item xs={6}>
                        {/* <Typography variant="body1">  <span style={circleStyle} /> Principal & Interest</Typography> */}
                        <Typography variant="body1">   <span style={{ ...circleStyle, backgroundColor: colorScheme[0] }} /> Principal & Interest</Typography>

                      </Grid>
                      <Grid item xs={6}>
                        <Controller
                          name="principalAndInterest"
                          //  disabled
                          control={control}
                          defaultValue={principalAndInterest} // Set defaultValue to display the initial value
                          render={({ field }) => (
                            <div style={{ display: 'flex', alignItems: 'center', width: '75%' }}>

                              <Typography variant="body1" style={{ marginRight: '18px' }}></Typography>
                              <TextField
                                {...field}
                                fullWidth

                                inputProps={{ style: { textAlign: 'right' } }} // Apply textAlign directly to inputProps
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start" className="adornment">
                                      <Typography variant="h6">$</Typography>
                                    </InputAdornment>
                                  ),
                                }}
                              />

                            </div>
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container item spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body1">   <span style={{ ...circleStyle, backgroundColor: colorScheme[1] }} /> Property Tax</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Controller
                          name="propertyTax"
                          control={control}
                          defaultValue={propertyTax} // Set defaultValue to display the initial value
                          render={({ field }) => (
                            <div style={{ display: 'flex', alignItems: 'left', width: '75%' }}>
                              <Typography variant="body1" style={{ marginRight: '5px' }}>+</Typography>
                              <TextField
                                {...field}
                                fullWidth
                                inputProps={{ style: { textAlign: 'right' } }} // Apply textAlign directly to inputProps
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start" className="adornment">
                                      <Typography variant="h6">$</Typography>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container item spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body1">   <span style={{ ...circleStyle, backgroundColor: colorScheme[2] }} /> Homeowner's Insurance</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Controller
                          name="homeInsurance"
                          control={control}
                          defaultValue={homeInsurance} // Set defaultValue to display the initial value
                          render={({ field }) => (
                            <div style={{ display: 'flex', alignItems: 'center', width: '75%' }}>
                              <Typography variant="body1" style={{ marginRight: '5px' }}>+</Typography>
                              <TextField
                                {...field}
                                fullWidth
                                inputProps={{ style: { textAlign: 'right' } }} // Apply textAlign directly to inputProps
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start" className="adornment">
                                      <Typography variant="h6">$</Typography>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container item spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body1">   <span style={{ ...circleStyle, backgroundColor: colorScheme[3] }} /> PMI</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Controller
                          name="pmi"
                          control={control}
                          defaultValue={pmi} // Set defaultValue to display the initial value
                          render={({ field }) => (
                            <div style={{ display: 'flex', alignItems: 'center', width: '75%' }}>
                              <Typography variant="body1" style={{ marginRight: '5px' }}>+</Typography>
                              <TextField
                                {...field}
                                fullWidth
                                inputProps={{ style: { textAlign: 'right' } }} // Apply textAlign directly to inputProps
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start" className="adornment">
                                      <Typography variant="h6">$</Typography>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container item spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body1">  <span style={{ ...circleStyle, backgroundColor: colorScheme[4] }} /> HOA Fees</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Controller
                          name="hoaFees"
                          control={control}
                          defaultValue={hoaFees} // Set defaultValue to display the initial value

                          render={({ field }) => (
                            <div style={{ display: 'flex', alignItems: 'center', width: '75%' }}>
                              <Typography variant="body1" style={{ marginRight: '5px' }}>+</Typography>
                              <TextField
                                {...field}
                                fullWidth
                                inputProps={{ style: { textAlign: 'right' } }
                                } // Apply textAlign directly to inputProps
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start" className="adornment">
                                      <Typography variant="h6">$</Typography>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                          )}
                        />
                      </Grid>
                    </Grid>
                    <Grid container item spacing={2}>
                      <Grid item xs={6}>
                        <Typography variant="body1">Total Monthly Payment</Typography>
                      </Grid>
                      <Grid item xs={6}>
                        <Controller
                          name="totalMonthlyPayment"
                          control={control}
                          defaultValue={totalMonthlyPayment}

                          render={({ field }) => (
                            <div style={{ display: 'flex', alignItems: 'center', width: '75%' }}>
                              <Typography variant="body1" style={{ marginRight: '5px' }}>=</Typography>
                              <TextField
                                {...field}
                                fullWidth
                                inputProps={{ style: { textAlign: 'right' } }} // Apply textAlign directly to inputProps
                                InputProps={{
                                  startAdornment: (
                                    <InputAdornment position="start" className="adornment">
                                      <Typography variant="h6">$</Typography>
                                    </InputAdornment>
                                  ),
                                }}
                              />
                            </div>
                          )}
                        />

                      </Grid>
                    </Grid>
                  </Grid>


                </Box>
              </Grid>
            </Grid>
          </Grid>

          <Grid item mt={2}>
            <Divider />
          </Grid>




        </Grid>
        {/* </Box> */}
        <Grid ml={2} mr={2}><CalInfo /> </Grid>
      </form>

    </>
  );
}

//
export default Cal2;